// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"67d009b2","239":"832267bb","453":"dd7665e0","732":"60f38994"}[chunkId] + ".chunk.js";
};